import { render } from "./TaskDetails.vue?vue&type=template&id=d241fb54"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"

import "./TaskDetails.vue?vue&type=style&index=0&id=d241fb54&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__